const baseUrl = '__baseUrl__'
const version1 = 'v1.0'
const version2 = 'v2.0'
const oksmBaseUrl = '__oksmBaseUrl__'

export const environment = {
  auth0Config: {
    clientID: '__auth0ConfigClientId__',
    domain: '__auth0ConfigDomain__',
    responseType: 'token id_token',
    audience: '__auth0ConfigAudience__',
    redirectUri: '__auth0ConfigRedirectUri__',
    scope: 'openid email profile roles companyservice:access',
    inAppRedirects: {
      loggedIn: '/restricted-product',
      error: '/',
    },
    silentAuthPage: '__auth0ConfigSilentAuthPage__',
    logoutUrl: '__auth0ConfigLogoutPage__',
  },
  production: true,
  baseUrl,
  version1,
  version2,
  restrictedProductUrl: baseUrl + version1 + '/restrictedProductAccounts',
  procomAccountsUrl: baseUrl + version1 + '/ProcomAccounts',
  masterDataUrl: baseUrl + version1 + '/MasterData',
  oksmUrl: oksmBaseUrl + 'Permissions/allowed',
  usersUrl: baseUrl + version1 + '/users',
  companyUrl: baseUrl + version1 + '/Companies',
  organizationsUrl: baseUrl + version1 + '/organizations',
  addressesURL: baseUrl + version2 + '/addresses',
  legalUrl: 'https://profile.allegion.com/tos',
  appInsightsCorrelationDomains: '__appInsightsCorrelationDomains__',
  appInsightsInstrumentationKey: '__appInsightsInstrumentationKey__',
  sentryDsn: '__sentryDsn__',
  sentryEnvironment: '__sentryEnvironment__',
}
